import { BrandGrid, ScreenHeader } from "@/components";
import { useAppSelector } from "@/store/hooks";

import React from "react";

const Brands: React.FC = () => {
  const {brands} = useAppSelector((state) => state.app);


  return (
    <>
      <BrandGrid
        gridItems={brands}
        sectionHeader={
          <ScreenHeader
            title="Shop by Brand"
            description="Browse all our professional salon brands"
          />
        }
      />
    </>
  );
};

export default Brands;
